// extracted by mini-css-extract-plugin
export var copyButtonContent = "w_dGq6idkGFnLlvM1tRA";
export var copyIcon = "xhI8G5Be8jzMjV8sHcNw";